"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetDueToLoad = exports.setCurrentFrame = exports.update = exports.addCrcCheckToBuffer = exports.addMessageToBuffer = exports.setIsRunning = exports.isPlayerOnCorrectGameSync = exports.updateGameSyncNumberForPlayer = exports.getSyncedImportantRando = exports.getUUnsyncedUnimportantRando = exports.getSyncedUnimportantRando = exports.get2frameIdx = exports.getPartialTick = exports.synced_createId = exports.addToAfterLevelMessageQueue = exports.addGenerator = exports.setMode = exports.getCurrentVisibilityIndex = exports.getIsTickFrame = exports.get = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveBullets_sidecar_1 = require("@dive/entities/diveBullets-sidecar");
var diveBullets_crc_sidecar_1 = require("@dive/entities/diveBullets_crc-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveObjectsData_1 = require("@dive/entities/diveObjectsData");
var diveObjects_crc_sidecar_1 = require("@dive/entities/diveObjects_crc-sidecar");
var diveSpells_sidecar_1 = require("@dive/spells/data/diveSpells-sidecar");
var diveSpells_crc_sidecar_1 = require("@dive/spells/data/diveSpells_crc-sidecar");
var diveSpell_firewall_sidecar_1 = require("@dive/spells/diveSpell_firewall-sidecar");
var diveSpell_lightningCloud_sidecar_1 = require("@dive/spells/diveSpell_lightningCloud-sidecar");
var randoInstanced_sidecar_1 = require("@dive/to-engine/randoInstanced-sidecar");
var diveUi_abilitiesBar_sidecar_1 = require("@dive/ui/diveUi_abilitiesBar-sidecar");
var diveCalcHeroVisibility_sidecar_1 = require("@dive/visibility/diveCalcHeroVisibility-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var diveCrew_crc_sidecar_1 = require("@voyage/crew/diveCrew_crc-sidecar");
var diveCrew_movable_sidecar_1 = require("@voyage/crew/diveCrew_movable-sidecar");
var voyageWebsockets_1 = require("@voyage/multi-sockets/voyageWebsockets");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var diveMessage_alterEntity_sidecar_1 = require("@voyage/multi/diveMessage_alterEntity-sidecar");
var diveMessage_mouseInput_1 = require("@voyage/multi/diveMessage_mouseInput");
var diveMessage_simulationFrame_sidecar_1 = require("@voyage/multi/diveMessage_simulationFrame-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var diveMisc_crc_sidecar_1 = require("./diveMisc_crc-sidecar");
var diveSimulationDirector_sidecar_1 = require("./diveSimulationDirector-sidecar");
var diveSimulationManager_sidecar_1 = require("./diveSimulationManager-sidecar");
var diveSimulationManager_generatorManager_sidecar_1 = require("./diveSimulationManager_generatorManager-sidecar");
// TODO: use new common simulation manager with extensions
var namespace = 'dive-simulation-manager';
var debugSlowSimulationTime = false;
var debugSlowSimulationTimeMultiplier = 10;
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            simulationMode: 'none',
            generator: null,
            gameSyncNumber: 7,
            currentSimuationFrame: 0,
            nextMessageSimulationFrame: 0,
            simulationFrameDelay: 1,
            simulateToFrame: 0,
            frameTimeSeconds: debugSlowSimulationTime
                ? 0.1 * debugSlowSimulationTimeMultiplier
                : 0.1,
            frameTimeAccumulator: 0,
            frameTimeAccumulator_waitingForNextFrame: false,
            isRunning: false,
            isTickFrame: false,
            bufferedCommands: [],
            afterLevelMessageQueue: [],
            playerGameSyncNumbers: {},
            syncErrorReport: '',
            nextFrameCrc_crew: 0,
            nextFrameCrc_bullets: 0,
            nextFrameCrc_objects: 0,
            nextFrameCrc_spells: 0,
            nextFrameCrc_misc: 0,
            nextFrameCrcFrame: 0,
            unsyncedUnimportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(new Date().getTime()),
            syncedUnimportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(0 + 1),
            syncedImportantRando: randoInstanced_sidecar_1.randoInstanced.createRando(0 + 1 + 1),
            synced_idCounter: 1000,
        };
        resetDueToLoad();
    }
    return _obj;
};
exports.get = get;
function getIsTickFrame() {
    return exports.get().isTickFrame;
}
exports.getIsTickFrame = getIsTickFrame;
function getCurrentVisibilityIndex() {
    return exports.get().currentSimuationFrame;
}
exports.getCurrentVisibilityIndex = getCurrentVisibilityIndex;
function setMode(mode) {
    var obj = exports.get();
    obj.simulationMode = mode;
}
exports.setMode = setMode;
function addGenerator(gen) {
    // let obj = get()
    // obj.generator = gen
    diveSimulationManager_generatorManager_sidecar_1.diveSimulationManager_generatorManager.addGenerator(gen);
}
exports.addGenerator = addGenerator;
function addToAfterLevelMessageQueue(msg) {
    var obj = exports.get();
    obj.afterLevelMessageQueue.push(msg);
}
exports.addToAfterLevelMessageQueue = addToAfterLevelMessageQueue;
// make sure IDs are the same across clients
function synced_createId(existingId) {
    if (existingId === void 0) { existingId = 0; }
    var obj = exports.get();
    // TODO: check for duplicate ids
    if (existingId) {
        if (existingId > obj.synced_idCounter) {
            obj.synced_idCounter = existingId;
            console.warn('synced_createId', 'existingId is greater than synced_idCounter');
        }
        return existingId;
    }
    obj.synced_idCounter++;
    return obj.synced_idCounter;
}
exports.synced_createId = synced_createId;
// Get fraction of tick for lerping / interpolation
function getPartialTick() {
    var obj = exports.get();
    if (obj.frameTimeAccumulator_waitingForNextFrame) {
        return 1;
    }
    var partialTick = obj.frameTimeAccumulator / (obj.frameTimeSeconds || 0.1);
    partialTick = mathUtils_sidecar_1.mathUtils.clamp1(partialTick);
    // console.log(
    //   namespace,
    //   'getPartialTick',
    //   partialTick,
    //   obj.currentSimuationFrame,
    // )
    return partialTick;
}
exports.getPartialTick = getPartialTick;
// Used for animation bouncing
function get2frameIdx() {
    var obj = exports.get();
    var idx = obj.currentSimuationFrame % 10;
    if (idx >= 5) {
        return 1;
    }
    return 0;
}
exports.get2frameIdx = get2frameIdx;
function getSyncedUnimportantRando() {
    var obj = exports.get();
    return obj.syncedUnimportantRando;
}
exports.getSyncedUnimportantRando = getSyncedUnimportantRando;
function getUUnsyncedUnimportantRando() {
    var obj = exports.get();
    return obj.unsyncedUnimportantRando;
}
exports.getUUnsyncedUnimportantRando = getUUnsyncedUnimportantRando;
function getSyncedImportantRando() {
    var obj = exports.get();
    return obj.syncedImportantRando;
}
exports.getSyncedImportantRando = getSyncedImportantRando;
function updateGameSyncNumberForPlayer(playerId, gameSyncNumber) {
    var obj = exports.get();
    obj.gameSyncNumber = gameSyncNumber;
    console.log(namespace, 'updateGameSyncNumberForPlayer', playerId, gameSyncNumber);
    obj.playerGameSyncNumbers[playerId] = gameSyncNumber;
}
exports.updateGameSyncNumberForPlayer = updateGameSyncNumberForPlayer;
function isPlayerOnCorrectGameSync(playerId) {
    if (playerId === 0) {
        return true; // Hack?
    }
    var obj = exports.get();
    var isInSync = obj.playerGameSyncNumbers[playerId] === obj.gameSyncNumber;
    if (!isInSync) {
        console.log(namespace, 'isPlayerOnCorrectGameSync', playerId, obj.playerGameSyncNumbers[playerId], obj.gameSyncNumber);
    }
    return isInSync;
}
exports.isPlayerOnCorrectGameSync = isPlayerOnCorrectGameSync;
function setIsRunning(isRunning) {
    console.log(namespace, 'setIsRunning', isRunning);
    var obj = exports.get();
    // Reset
    obj.isRunning = isRunning;
    obj.gameSyncNumber++;
    resetDueToLoad();
    //websockets.setSimulationFrame(0)
}
exports.setIsRunning = setIsRunning;
function addMessageToBuffer(msg) {
    var obj = exports.get();
    obj.bufferedCommands.push({ mouseInput: msg });
}
exports.addMessageToBuffer = addMessageToBuffer;
function addCrcCheckToBuffer(msg) {
    var obj = exports.get();
    obj.nextFrameCrc_crew = msg.crc_crew;
    obj.nextFrameCrc_bullets = msg.crc_bullets;
    obj.nextFrameCrc_objects = msg.crc_objects;
    obj.nextFrameCrc_spells = msg.crc_spells;
    obj.nextFrameCrc_misc = msg.crc_misc;
    obj.nextFrameCrcFrame = msg.frame;
}
exports.addCrcCheckToBuffer = addCrcCheckToBuffer;
function update() {
    var obj = exports.get();
    var isHost = voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost();
    // console.log(
    //   'simulation',
    //   obj.isRunning,
    //   obj.frameTimeAccumulator,
    //   obj.currentSimuationFrame,
    //   obj.simulateToFrame,
    // )
    if (obj.nextMessageSimulationFrame <= obj.currentSimuationFrame) {
        obj.nextMessageSimulationFrame =
            obj.currentSimuationFrame + obj.simulationFrameDelay;
    }
    // Do we have a running generator?
    if (diveSimulationManager_generatorManager_sidecar_1.diveSimulationManager_generatorManager.hasGenerator()) {
        diveSimulationManager_generatorManager_sidecar_1.diveSimulationManager_generatorManager.update();
        console.log(namespace, 'generating');
        obj.frameTimeAccumulator = 0;
        return;
    }
    // Are we generating?
    if (obj.simulationMode === 'generating') {
        console.log(namespace, 'generating');
        obj.frameTimeAccumulator = 0;
        return;
    }
    if (!obj.isRunning) {
        // console.log(namespace, 'paused')
        obj.frameTimeAccumulator = 0;
        return;
    }
    else {
        // console.log(
        //   namespace,
        //   'running',
        //   obj.currentSimuationFrame,
        //   obj.simulateToFrame,
        //   obj.frameTimeAccumulator,
        // )
    }
    if (obj.simulationMode !== 'game') {
        return;
    }
    // One frame max per frame, catchup
    // obj.simulateToFrame = websockets.getSimulationFrame()
    if (isHost) {
        var delta = common_sidecar_1.common.getUpdateDelta();
        var deltaMax = obj.frameTimeSeconds;
        if (delta > deltaMax) {
            delta = deltaMax;
        }
        obj.frameTimeAccumulator += delta;
        // console.log('update')
        if (obj.frameTimeAccumulator > obj.frameTimeSeconds &&
            obj.currentSimuationFrame === obj.simulateToFrame // Make sure we are caught up
        ) {
            obj.frameTimeAccumulator -= obj.frameTimeSeconds;
            obj.frameTimeAccumulator_waitingForNextFrame = true;
            // Send out message to simulate next frame
            obj.nextMessageSimulationFrame =
                obj.currentSimuationFrame + 1 + obj.simulationFrameDelay;
            var crc_crew = 0;
            var crc_bullets = 0;
            var crc_objects = 0;
            var crc_spells = 0;
            var crc_misc = 0;
            if (diveSimulationManager_sidecar_1.diveSimulationManager.get().isRunning) {
                crc_crew = diveCrew_crc_sidecar_1.diveCrew_crc.getCrc();
                crc_bullets = diveBullets_crc_sidecar_1.diveBullets_crc.getCrc();
                crc_objects = diveObjects_crc_sidecar_1.diveObjects_crc.getCrc();
                crc_spells = diveSpells_crc_sidecar_1.diveSpells_crc.getCrc();
                crc_misc = diveMisc_crc_sidecar_1.diveMisc_crc.getCrc();
            }
            var msg = {
                frame: obj.currentSimuationFrame + 1,
                gameSyncNumber: obj.gameSyncNumber,
                crc_crew: crc_crew,
                crc_bullets: crc_bullets,
                crc_objects: crc_objects,
                crc_spells: crc_spells,
                crc_misc: crc_misc,
            };
            // console.log(
            //   namespace,
            //   'send simulation frame',
            //   msg.gameSyncNumber,
            //   msg.frame,
            // )
            diveMessage_simulationFrame_sidecar_1.diveMessage_simulationFrame.sendMessageToAll(msg);
        }
    }
    else {
        // TODO: get partial frames working for client 23dgsdf4234
        // let delta = common.getUpdateDelta()
        // const deltaMax = obj.frameTimeSeconds
        // if (delta > deltaMax) {
        //   delta = deltaMax
        // }
        // obj.frameTimeAccumulator += delta
        // if (
        //   obj.frameTimeAccumulator > obj.frameTimeSeconds &&
        //   obj.currentSimuationFrame === obj.simulateToFrame // Make sure we are caught up
        // ) {
        //   obj.frameTimeAccumulator -= obj.frameTimeSeconds
        //   obj.frameTimeAccumulator_waitingForNextFrame = true
        // }
    }
    obj.isTickFrame = false;
    if (obj.currentSimuationFrame < obj.simulateToFrame) {
        // console.log(
        //   'updating frame',
        //   obj.currentSimuationFrame,
        //   obj.simulateToFrame,
        // )
        updateFrame();
        updateFrame_processMessages();
    }
}
exports.update = update;
function setCurrentFrame(frame) {
    var obj = exports.get();
    obj.currentSimuationFrame = frame;
    // TODO: add a seed that is unique to the world, for playback? Or have an absolute frame or something? Or an absolute rnd seed?
    obj.syncedUnimportantRando.setCurrentSeed(obj.gameSyncNumber * 10000 + obj.currentSimuationFrame + 1);
    obj.syncedImportantRando.setCurrentSeed(obj.gameSyncNumber * 10000 + obj.currentSimuationFrame + 1 + 17025);
    console.log(namespace, 'synced number', obj.gameSyncNumber, obj.currentSimuationFrame);
}
exports.setCurrentFrame = setCurrentFrame;
function resetDueToLoad() {
    setCurrentFrame(0);
    var obj = exports.get();
    obj.simulateToFrame = 0;
    // websockets.setSimulationFrame(0) // TODO: get rid of this extra complexity?
    obj.nextFrameCrc_crew = 0;
    obj.nextFrameCrc_bullets = 0;
    obj.nextFrameCrc_spells = 0;
    obj.nextFrameCrcFrame = 0;
    obj.nextMessageSimulationFrame = 0 + obj.simulationFrameDelay;
    obj.frameTimeAccumulator = 0;
    // Send all of our after load messages
    var afterLevelMessageQueue = obj.afterLevelMessageQueue;
    afterLevelMessageQueue.forEach(function (msg) {
        console.log('sending after level message', msg);
        diveMessage_alterEntity_sidecar_1.diveMessage_alterEntity.sendMessageToAll(msg);
    });
    obj.afterLevelMessageQueue = [];
    // obj.synced_idCounter =
}
exports.resetDueToLoad = resetDueToLoad;
function updateFrame() {
    var obj = exports.get();
    obj.isTickFrame = true;
    var nextFrame = obj.currentSimuationFrame + 1;
    // Check our CRC at the start of this frame
    if (obj.nextFrameCrcFrame === nextFrame) {
        obj.syncErrorReport = '';
        var checkCrc = function (crcName, crcA, crcB) {
            if (crcA !== crcB) {
                console.warn('crc mismatch', nextFrame, crcName, crcA, crcB);
                if (obj.syncErrorReport) {
                    obj.syncErrorReport += ',';
                }
                obj.syncErrorReport += crcName;
            }
        };
        checkCrc('crew', obj.nextFrameCrc_crew, diveCrew_crc_sidecar_1.diveCrew_crc.getCrc());
        checkCrc('bullets', obj.nextFrameCrc_bullets, diveBullets_crc_sidecar_1.diveBullets_crc.getCrc());
        checkCrc('objects', obj.nextFrameCrc_objects, diveObjects_crc_sidecar_1.diveObjects_crc.getCrc());
        checkCrc('spells', obj.nextFrameCrc_spells, diveSpells_crc_sidecar_1.diveSpells_crc.getCrc());
        checkCrc('misc', obj.nextFrameCrc_misc, diveMisc_crc_sidecar_1.diveMisc_crc.getCrc());
        if (!obj.syncErrorReport) {
            obj.syncErrorReport = 'ok';
        }
    }
    setCurrentFrame(nextFrame);
    // Tick updates
    diveCalcHeroVisibility_sidecar_1.diveCalcHeroVisibility.calcHeroVisibility_updateTick();
    diveObjects_sidecar_1.diveObjects.updateTickAll();
    diveCrew_sidecar_1.diveCrew.updateTickAll();
    diveBullets_sidecar_1.diveBullets.updateTickAll();
    diveSpells_sidecar_1.diveSpells.updateTickAll();
    // console.log('???')
    diveSimulationDirector_sidecar_1.diveSimulationDirector.updateTick();
}
function updateFrame_processMessages() {
    var _a, _b;
    var obj = exports.get();
    var commands = obj.bufferedCommands;
    var continueProcessing = true;
    var _loop_1 = function () {
        var peek = commands[0];
        if (peek.simulationFrame) {
            console.log('SIMULATION FRAME still is being used');
            if (voyageWebsockets_1.getIsHost()) {
                // Host skips crc checks, as they will sometimes already be ahead (?)
                // Not really sure why the host crc is off sometimes, this could cause problems
                var crc = (_a = commands.shift()) === null || _a === void 0 ? void 0 : _a.simulationFrame;
            }
            else {
                var peekCrc = peek.simulationFrame;
                if (peekCrc.frame < obj.currentSimuationFrame) {
                    commands.shift();
                    obj.syncErrorReport = 'OOB';
                    console.error('out of frame bounds, crc out of order', peekCrc, peekCrc.frame, obj.currentSimuationFrame);
                    return "continue";
                    // throw new Error('out of frame bounds, crc out of order')
                }
                if (peekCrc.frame > obj.currentSimuationFrame) {
                    // Future frames, process later
                    continueProcessing = false;
                    return "break";
                }
                // console.log('crc1', 'crew', peek.crc_crew, diveCrew_hero.getCrc())
                // Process this message
                var crc = (_b = commands.shift()) === null || _b === void 0 ? void 0 : _b.simulationFrame;
                assert_sidecar_1.assert.notNil(crc);
                // Check this crc
                // TODO: this is checked elsewhere
                // if (crc.crc_crew) {
                //   let crc_crew = diveCrew_crc.getCrc()
                //   // console.log('crc', 'crew', peek.crc_crew, crc_crew)
                //   if (crc.crc_crew !== crc_crew) {
                //     console.warn('crc mismatch', 'crew', crc.crc_crew, crc_crew)
                //     obj.syncErrorReport = 'crew'
                //   } else {
                //     obj.syncErrorReport = ''
                //   }
                //   // assert.eq(peek.crc_crew, diveCrew_hero.getCrc())
                // }
            }
        }
        if (peek.mouseInput) {
            var mi = peek.mouseInput;
            if (mi.frame < obj.currentSimuationFrame) {
                commands.shift();
                console.error('out of frame bounds, msg out of order', mi, mi.frame, obj.currentSimuationFrame);
                return "continue";
            }
            if (mi.frame > obj.currentSimuationFrame) {
                // Future frames, process later
                continueProcessing = false;
                return "break";
            }
            // Process this message
            commands.shift();
            // TODO: move processing of mouse input elsewhere
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.SelectCrew) {
                voyagePicker_sidecar_1.voyagePicker.nx_setSelection(mi);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.Move) {
                diveCrew_movable_sidecar_1.diveCrew_movable.nx_pathTo(mi);
            }
            var _c = voyageWebsockets_sidecar_1.voyageWebsockets.isUsEx(mi.fromMultiId), isUs_1 = _c.isUs, from_1 = _c.from;
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.Cast) {
                diveSpells_sidecar_1.diveSpells.nx_castSpell(mi);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.Smash) {
                diveObjects_sidecar_1.diveObjects.nx_smash(mi);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.Open) {
                diveObjects_sidecar_1.diveObjects.nx_open(mi);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.PickUp) {
                diveObjects_sidecar_1.diveObjects.nx_pickUp(mi);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.SetPreferredTarget) {
                voyagePicker_sidecar_1.voyagePicker.nx_setPreferredTarget(mi);
            }
            // TODO: affect multiplayer cursors if not us
            var setAbility = function (spell) {
                if (isUs_1) {
                    voyagePicker_sidecar_1.voyagePicker.setCursorMode('cast');
                    voyagePicker_sidecar_1.voyagePicker.get().selectedSpell = spell;
                }
                else if (from_1) {
                    from_1.pickMode = 'cast';
                    from_1.selectedSpell = spell;
                }
            };
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.CancelAbility) {
                if (isUs_1) {
                    diveUi_abilitiesBar_sidecar_1.diveUi_abilitiesBar.cancelAbility();
                }
                else if (from_1) {
                    from_1.pickMode = 'normal';
                    from_1.selectedSpell = null;
                }
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_useItem) {
                diveObjects_sidecar_1.diveObjects.nx_use(mi, diveObjectsData_1.EDiveEquipSlot.Item);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropItem) {
                diveObjects_sidecar_1.diveObjects.nx_drop(mi, diveObjectsData_1.EDiveEquipSlot.Item);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropLoot) {
                diveObjects_sidecar_1.diveObjects.nx_drop(mi, diveObjectsData_1.EDiveEquipSlot.Loot);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_basic_dropWeapon) {
                diveObjects_sidecar_1.diveObjects.nx_drop(mi, diveObjectsData_1.EDiveEquipSlot.Weapon);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_firewall) {
                setAbility(diveSpell_firewall_sidecar_1.diveSpell_firewall);
            }
            if (mi.hint === diveMessage_mouseInput_1.EDiveInputHint.SelectAbility_lightningCloud) {
                setAbility(diveSpell_lightningCloud_sidecar_1.diveSpell_lightningCloud);
            }
        }
    };
    while (continueProcessing && commands.length > 0) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
}
